import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    const stored = localStorage.getItem("dmaskut-theme");
    if (stored) return stored;
    return "light"; // Always default to light mode
  });

  useEffect(() => {
    const checkMobileAndSetTheme = () => {
      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        setTheme("light");
      }
    };

    checkMobileAndSetTheme();
    window.addEventListener('resize', checkMobileAndSetTheme);
    window.addEventListener('orientationchange', checkMobileAndSetTheme);

    return () => {
      window.removeEventListener('resize', checkMobileAndSetTheme);
      window.removeEventListener('orientationchange', checkMobileAndSetTheme);
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("dmaskut-theme", theme);
  }, [theme]);

  const toggle = () => {
    const isMobile = window.innerWidth < 1024;
    if (isMobile) return; // Don't allow theme toggle on mobile
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};
